<template>
  <header class="text-lg leading-6 font-medium text-gray-900">
    <slot />
  </header>
</template>

<script>
export default {
  name: 'ActionPanelHeading'
}
</script>
